import React from 'react';
import { connect } from 'react-redux';
import { isNull, isEmpty } from 'lodash';

import mea from '../../../services/mea';
import { PATH } from '../../../constants/path';
import { CONTEXT_ROOT } from '../../../constants';

import { fetchFaqIfNeeded } from '../../../services/faq/actions';

import { convertHtmlToReactDomWithParams } from '../../../utils/htmlUtils';

import HeadComponent from '../../HeadComponent';
import { withTemplate } from '../../template/withTemplate';
import HowItWorksComponent from '../../HowItWorksComponent';
import FaqElementComponent from '../faq/FaqElementComponent';
import CarouselComponent from '../../carousel/CarouselComponent';
import { PrimaryTemplate } from '../../template/PrimaryTemplate';
import CustomerServiceComponent from '../../CustomerServiceComponent';
import ItemCarrouselComponent from '../../carousel/ItemCarrouselComponent';

import './HomePage.scss';

const carouselOptions = {
    dots: false,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1
};

export class HomePage extends React.Component {
    componentDidMount() {
        this.props.fetchMeasIfNeeded(mea.constants.CAROUSEL_MEA_TYPE);
        this.props.fetchFaqIfNeeded();
    }

    renderCarouselMeas = () => {
        const { partners, ebonPartners, carrouselMeas } = this.props;

        if ((partners || ebonPartners) && carrouselMeas && carrouselMeas.length > 0) {
            return (
                <section className="accueil-carousel">
                    <CarouselComponent options={carouselOptions}>
                        {carrouselMeas
                            .sort((a, b) => a.ordreAffichage - b.ordreAffichage)
                            .map((item, i) => {
                                return item.ebon ? (
                                    <ItemCarrouselComponent
                                        item={item}
                                        key={i}
                                        partner={
                                            ebonPartners.find(p => item.idPartenaire === p.id)
                                                ? ebonPartners.find(p => item.idPartenaire === p.id)
                                                : null
                                        }
                                        isEbon
                                    />
                                ) : (
                                    <ItemCarrouselComponent
                                        item={item}
                                        key={i}
                                        partner={
                                            partners[item.idPartenaire]
                                                ? partners[item.idPartenaire]
                                                : null
                                        }
                                        isOffline={item.offline}
                                    />
                                );
                            })}
                    </CarouselComponent>
                </section>
            );
        }
    };

    render() {
        const {
            i18nHome,
            i18nHowItWorks,
            BRAND_NAME_ALT,
            faqData,
            i18nCustomerService
        } = this.props;
        const theme = faqData.find(e => !isEmpty(e.faqs)) || null;

        return (
            <React.Fragment>
                <main id="p-accueil-first-half" className="conteneur">
                    <div className="conteneur">
                        <HeadComponent
                            title={i18nHome.TITLE}
                            description={i18nHome.DESCRIPTION}
                            canonicalLink={`${CONTEXT_ROOT}${PATH.HOME_PATH}`}
                        />

                        {this.renderCarouselMeas()}

                        <div className="conteneur-mobile">
                            <HowItWorksComponent showTitle showButtons />
                        </div>
                    </div>
                </main>

                <main id="p-accueil-second-half" className="conteneur conteneur-mobile">
                    <div className="ccm-text">
                        <h3>
                            {convertHtmlToReactDomWithParams(
                                i18nHowItWorks.TEXT1_1,
                                BRAND_NAME_ALT
                            )}
                        </h3>
                        <p>{convertHtmlToReactDomWithParams(i18nHowItWorks.TEXT1_2)}</p>
                        <ul>
                            <li>{i18nHowItWorks.TEXT1_3}</li>
                            <li>{i18nHowItWorks.TEXT1_4}</li>
                        </ul>
                        <p>{i18nHowItWorks.TEXT1_5}</p>

                        <h3>{i18nHowItWorks.TEXT2_1}</h3>
                        <p>{i18nHowItWorks.TEXT2_2}</p>
                        <p>{i18nHowItWorks.TEXT2_3}</p>
                        <p>{i18nHowItWorks.TEXT2_4}</p>
                        <p>{i18nHowItWorks.TEXT2_5}</p>
                    </div>

                    <hr />

                    <div className="help-container grid">
                        <div className="faq-container inbl">
                            <div className="faq-bandeau">{i18nHowItWorks.QUESTION}</div>
                            <div className="faq-list-container">
                                {!isNull(theme) &&
                                    theme.faqs
                                        .slice(0, 4)
                                        .map(faq => (
                                            <FaqElementComponent
                                                key={faq.id}
                                                faq={faq}
                                                cssClass="question-comment-ca-marche-page"
                                                forceArrowRight
                                                linkToFaqPage
                                            />
                                        ))}
                            </div>
                        </div>

                        <CustomerServiceComponent i18n={i18nCustomerService} />
                    </div>
                </main>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({
    carrouselMeas: mea.selectors.getMeasListByTypeId(state, mea.constants.CAROUSEL_MEA_TYPE),
    partners: state.partner.partners,
    ebonPartners: state.ebon.ebonPartners,
    i18nHome: state.i18n.page.HOME,
    i18nHowItWorks: state.i18n.page.HOW_IT_WORKS,
    i18nCustomerService: state.i18n.feature.aide.serviceclient,
    BRAND_NAME_ALT: state.i18n.common.BRAND_NAME_ALT,
    faqData: state.faq.faqs || []
});

const mapDispatchToProps = {
    fetchMeasIfNeeded: mea.actions.fetchMeasIfNeeded,
    fetchFaqIfNeeded
};

export default withTemplate(
    connect(mapStateToProps, mapDispatchToProps)(HomePage),
    PrimaryTemplate,
    {
        hideBreadcrumb: true
    }
);



// WEBPACK FOOTER //
// ./src/components/pages/home/HomePage.js